import { render } from "./AboutGrid.vue?vue&type=template&id=10814e4a&scoped=true"
import script from "./AboutGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutGrid.vue?vue&type=script&setup=true&lang=js"

import "./AboutGrid.vue?vue&type=style&index=0&id=10814e4a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10814e4a"],['__file',"resources/frontend/js/components/AboutGrid.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10814e4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10814e4a', __exports__)) {
    api.reload('10814e4a', __exports__)
  }
  
  module.hot.accept("./AboutGrid.vue?vue&type=template&id=10814e4a&scoped=true", () => {
    api.rerender('10814e4a', render)
  })

}


export default __exports__